"use client";

import { createContext, useContext } from "react";

/**
 * Provides a function to resolve a variable ID (e.g., "{{root.result.text}}")
 * to a human-readable display label (e.g., "1. Slack: New Direct Message: Text").
 *
 * Returns null if no label is available (falls back to raw path display).
 */
type VariableLabelResolver = (variableId: string) => string | null;
const VariableLabelContext = createContext<VariableLabelResolver>(() => null);
export const VariableLabelProvider = VariableLabelContext.Provider;
export function useVariableLabelResolver() {
  return useContext(VariableLabelContext);
}